import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'
import _imports_1 from '@/assets/img/exclamation-triangle-fill-yellow.svg'


const _withScopeId = n => (_pushScopeId("data-v-3fedced4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = {
  class: "layerToSelect",
  style: {"cursor":"default"}
}
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = { class: "table table-striped mb-4" }
const _hoisted_11 = { class: "w-50" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { colspan: "99" }
const _hoisted_14 = { class: "w-50" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_16 = { class: "table table-striped" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { colspan: "99" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = { class: "text-center mt-4 pt-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_25 = { class: "fw_700" }
const _hoisted_26 = { class: "text-center mt-5" }
const _hoisted_27 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Select destination layers",
          text: "Select destination layers"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.layer.layerName), 1)
        ]),
        _createVNode(_component_localized_text, {
          type: "h5",
          localizedKey: "Materials",
          text: "Materials"
        }),
        _hoisted_9,
        _createElementVNode("table", _hoisted_10, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_11, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Material",
                  text: "Material"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Percentage",
                  text: "Percentage"
                })
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.layer.fabricCompositions.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                  _createElementVNode("td", _hoisted_13, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "No Elements Found",
                      text: "No Elements Found"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layer.fabricCompositions, (material, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", _hoisted_14, _toDisplayString(material.rawMaterial.text), 1),
                _createElementVNode("td", null, _toDisplayString(material.percentage) + "%", 1)
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_localized_text, {
          type: "h5",
          localizedKey: "Transportation",
          text: "Transportation",
          class: "pt-2"
        }),
        _hoisted_15,
        _createElementVNode("table", _hoisted_16, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Material",
                  text: "Material"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Origin Country",
                  text: "Origin Country"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Destination Country",
                  text: "Destination Country"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Transports",
                  text: "Transports"
                })
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.layer.fabricCompositions.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                  _createElementVNode("td", _hoisted_18, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "No Elements Found",
                      text: "No Elements Found"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rawMaterialTransportPhases[_ctx.layer.layerName].filter( x => { return x.productionPhase == this.productionPhase }), (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(item.rawMaterial.text), 1),
                _createElementVNode("td", null, _toDisplayString(item.countryOfOrigin), 1),
                _createElementVNode("td", null, _toDisplayString(item.countryOfDestination), 1),
                _createElementVNode("td", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.transportTypes, (type, j) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "fs-12 mb-1",
                      key: j
                    }, _toDisplayString(type.transportType) + " - " + _toDisplayString(_ctx.$filters.approximation(type.transportCO2)), 1))
                  }), 128)),
                  (item.transportTypes.length == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "--"))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(_component_localized_text, {
        type: "h5",
        localizedKey: "Copy to",
        text: "Copy to",
        class: "d-block strong my-5 text-uppercase text-center"
      }),
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layerList.filter(x => x.layerName != _ctx.layer.layerName), (layer, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["layerToSelect me-2", { 'selected': _ctx.selectedLayersToCopy.indexOf(layer.layerName) > -1 }]),
            onClick: ($event: any) => (_ctx.toggleLayerFromList(layer.layerName)),
            key: index
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", {
                class: _normalizeClass(["sameAsCheckbox me-2", { 'active': _ctx.selectedLayersToCopy.indexOf(layer.layerName) > -1 }])
              }, null, 2),
              _createElementVNode("strong", null, _toDisplayString(layer.layerName), 1)
            ])
          ], 10, _hoisted_21))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createVNode(_component_localized_text, {
          localizedKey: "Materials, percentages and transports will be copied to the selected ones from this one:",
          text: "Materials, percentages and transports will be copied to the selected ones from this one:",
          type: "p",
          class: "mt-2 mb-1 w-75 mx-auto"
        }),
        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.layer.layerName), 1)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Confirm",
            text: "Confirm"
          })
        ], 8, _hoisted_27)
      ])
    ])
  ]))
}